// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__2hX9q","load8":"Loader_load8__1HCp5"};